import API from "../../routes/api.routes";
import { ApiMananger } from "../apiMananger";

export const parentApi = ApiMananger.injectEndpoints({
  endpoints: (build) => ({
    getParents: build.query({
      // query: () => API.PARENTS_API.GETALL(),
      query: ({ limit } = {}) =>
        limit ? `parents/?limit=${limit}&offset=0` : "parents/",
      providesTags: ["Parents"],
    }),

    getMessage: build.query({
      // query: () => API.PARENTS_API.GETALL(),
      query: () => "parents/contacts/",
      providesTags: [""],
    }),
    getProspects: build.query({
      query: (params = {}) => {
        const { category, page = 1, limit = 50 } = params;
        const baseUrl = API.PARENTS_API.GETPROSPECTS();
        const queryParams = new URLSearchParams();

        const offset = (page - 1) * limit;
        queryParams.append('limit', limit.toString());
        queryParams.append('offset', offset.toString());

        if (category) {
          queryParams.append('category', category);
        }
        return `${baseUrl}?${queryParams.toString()}`;
      },
      providesTags: ["Parents"],
      serializeQueryArgs: ({ queryArgs }) => {
        const { category, page, limit } = queryArgs || {};
        return `${category || 'all'}-${page || 1}-${limit || 50}`;
      },
    }),
    getProspectsStats: build.query({
      query: () => "prospects/stats/",
      providesTags: ["Parents"],
      // Réduire le temps de cache à 5 secondes pour avoir des stats à jour
      keepUnusedDataFor: 5,
    }),
    getProspectsSenAssurances: build.query({
      query: () => API.PARENTS_API.GETPROSPECTSSENASSURANCE(),
      providesTags: ["Parents"],
    }),
    // Statistiques de connexion globales
    getParentsLoginStats: build.query({
      query: ({ startDate, endDate, groupBy = "day" }) =>
        `parents/login-stats/?start_date=${startDate}&end_date=${endDate}&group_by=${groupBy}`,
      providesTags: ["ParentStats"],
    }),
    // Statistiques de connexion d'un parent spécifique
    getParentLoginStats: build.query({
      query: ({ parentId, startDate, endDate, groupBy = "day" }) => {
        let url = `parents/${parentId}/login-stats/?group_by=${groupBy}`;
        if (startDate) url += `&start_date=${startDate}`;
        if (endDate) url += `&end_date=${endDate}`;
        return url;
      },
      providesTags: ["ParentStats"],
    }),
    // Statistiques UTM (sources d'acquisition)
    getParentsUTMStats: build.query({
      query: ({ startDate, endDate, type } = {}) => {
        let url = "parents/utm-stats/?";
        const params = [];
        if (startDate) params.push(`start_date=${startDate}`);
        if (endDate) params.push(`end_date=${endDate}`);
        if (type) params.push(`type=${type}`);
        return url + params.join("&");
      },
      providesTags: ["ParentStats"],
    }),
    // Statistiques des activités d'un parent
    getParentActivitiesStats: build.query({
      query: ({ parentId, startDate, endDate, studentId } = {}) => {
        let url = `parents/${parentId}/activities-stats/?`;
        const params = [];
        if (startDate) params.push(`start_date=${startDate}`);
        if (endDate) params.push(`end_date=${endDate}`);
        if (studentId) params.push(`student_id=${studentId}`);
        return url + params.join("&");
      },
      providesTags: ["ParentStats"],
    }),
    // Statistiques des activités globales de tous les parents
    getAllParentsActivitiesStats: build.query({
      query: (params = {}) => {
        const queryParams = new URLSearchParams();
        if (params.start_date) queryParams.append("start_date", params.start_date);
        if (params.end_date) queryParams.append("end_date", params.end_date);
        if (params.classe_id) queryParams.append("classe_id", params.classe_id);
        if (params.category) queryParams.append("category", params.category);
        if (params.limit) queryParams.append("limit", params.limit);
        if (params.offset) queryParams.append("offset", params.offset);
        const qs = queryParams.toString();
        return qs ? `parents/all-activities-stats/?${qs}` : "parents/all-activities-stats/";
      },
      providesTags: ["ParentStats"],
    }),
    convertirProspect: build.query({
      query: (id) => {
        return {
          url: API.PARENTS_API.CONVERTPROSPECTS(id),
          method: "PUT",
          body: {
            type: "CONFIRMED",
          },
        };
      },
      // API.PARENTS_API.CONVERTPROSPECTS(id),
      invalidatesTags: ["Parents"],
    }),
    // Ramène un client à l'étape où il était avant sa conversion
  
    deconvertirProspect: build.mutation({
      query: ({ id, stageBeforeClient }) => ({
        url: API.PARENTS_API.CONVERTPROSPECTS(id),
        method: "PUT",
        body: {
          type: "PROSPECT",
          computed_category: stageBeforeClient || "PROSPECT",
        },
      }),
      invalidatesTags: ["Parents"],
    }),
    addParents: build.mutation({
      query({ body, token }) {
        return {
          url: API.PARENTS_API.ADD(),
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "X-CSRFToken": token,
          },
          body,
        };
      },
      invalidatesTags: ["Parents"],
    }),
    // changeStatus: build.mutation({
    //   query({ body }) {
    //     return {
    //       url: API.PARENTS_API.CHANGESTATUS(body?.id),
    //       method: "PUT",
    //       body,
    //     };
    //   },
    // query(id) {
    //   return {
    //     url: API.PARENTS_API.CHANGESTATUS(id),
    //     method: "PUT",
    //     // headers: {
    //     //   Accept: "application/json",
    //     //   "Content-Type": "application/json",
    //     //   "X-CSRFToken": token,
    //     // },
    //     body:{
    //       type:"CONFIRMED"
    //     }
    //     ,
    //   };
    // },
    //   invalidatesTags: ["Parents"],
    // }),
    EditParents: build.mutation({
      query({ body, token }) {
        return {
          url: API.PARENTS_API.EDIT(body?.id),
          method: "PUT",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "X-CSRFToken": token,
          },
          body,
        };
      },
      invalidatesTags: ["Parents"],
    }),
    deleteParents: build.mutation({
      query(id) {
        return {
          url: API.PARENTS_API.DELETE(id),
          method: "DELETE",
        };
      },
      invalidatesTags: ["Parents"],
    }),
  }),
});

export const {
  useGetParentsQuery,
  useAddParentsMutation,
  useEditParentsMutation,
  useDeleteParentsMutation,
  useGetProspectsQuery,
  useGetProspectsStatsQuery,
  useConvertirProspectQuery,
  useDeconvertirProspectMutation,
  useGetProspectsSenAssurancesQuery,
  useGetMessageQuery,
  useGetParentsLoginStatsQuery,
  useGetParentLoginStatsQuery,
  useGetParentsUTMStatsQuery,
  useGetParentActivitiesStatsQuery,
  useGetAllParentsActivitiesStatsQuery,
  useLazyGetAllParentsActivitiesStatsQuery,
} = parentApi;
